


jQuery(document).ready(function ($) {

    function initAccordion() {

        // Remove old click events first
        $('.comparison-accordion .accordion-header').off('click');

        if ($(window).width() <= 767) {

            $('.comparison-accordion .accordion-header').on('click', function () {

                const $item = $(this).closest('.accordion-item');
                const $content = $item.find('.accordion-content');
                const $icon = $(this).find('.accordion-icon');

                // Close other items
                $item.siblings('.accordion-item')
                    .removeClass('active')
                    .find('.accordion-content')
                    .slideUp();

                $item.siblings('.accordion-item')
                    .find('.accordion-icon')
                    .text('+');

                // Toggle current
                $item.toggleClass('active');
                $content.stop(true, true).slideToggle();

                // Change icon
                if ($item.hasClass('active')) {
                    $icon.text('−');
                } else {
                    $icon.text('+');
                }

            });

        } else {

            // Desktop reset
            $('.comparison-accordion .accordion-content').show();
            $('.comparison-accordion .accordion-item').removeClass('active');
            $('.comparison-accordion .accordion-icon').text('');

        }

    }

    // Initial load
    initAccordion();

    // On resize
    $(window).on('resize', function () {

        initAccordion();

    });

});














jQuery(document).ready(function ($) {

    function equalRowHeights() {

        if ($(window).width() < 768) return;

        // Process EACH table separately
        $('.comparison-accordion.desktop').each(function () {

            let table = $(this);

            // Remove old empty rows only inside current table
            table.find('.empty-li').remove();

            // Reset heights
            table.find('li').css('height', 'auto');

            let columns = [];

            // Get columns
            table.find('.accordion-item').each(function () {

                let ul = $(this).find('ul');
                let lis = ul.children('li');

                columns.push({
                    ul: ul,
                    lis: lis
                });

            });

            // Find max rows in THIS table only
            let maxRows = Math.max(...columns.map(col => col.lis.length));

            // Add empty rows only to shorter columns
            columns.forEach(function (col) {

                let missing = maxRows - col.lis.length;

                if (missing > 0) {

                    for (let i = 0; i < missing; i++) {

                        col.ul.append('<li class="empty-li"></li>');

                    }

                }

            });

            // Refresh columns
            let updatedColumns = [];

            table.find('.accordion-item').each(function () {

                updatedColumns.push($(this).find('li'));

            });

            // Equal heights row-wise
            for (let i = 0; i < maxRows; i++) {

                let maxHeight = 0;

                updatedColumns.forEach(function (col) {

                    if (col[i]) {

                        let h = $(col[i]).outerHeight();

                        if (h > maxHeight) {
                            maxHeight = h;
                        }

                    }

                });

                updatedColumns.forEach(function (col) {

                    if (col[i]) {

                        $(col[i]).css('height', maxHeight + 'px');

                    }

                });

            }

        });

    }

    equalRowHeights();

    $(window).on('resize', equalRowHeights);

});